<script lang="ts">
    import { type TagNodeObject } from '$lib/bbcode/parser/types';
    import * as z from 'zod';
    import { parseAttrs } from '$lib/bbcode/parseBBcode';

    export let node: TagNodeObject;
    $: attrs = parseAttrs(
        z.object({
            name: z.string().nullish(),
        }),
        node.attrs,
    );

    $: slotName = attrs.name ?? attrs.__default ?? '';
</script>

<slot {slotName} slotContent={node.content} />
